var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyChatChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "property-chat-channel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "property-chat-channel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "channel",
    transform: "translate(26.000000, 26.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 9,
    y2: 24,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 0,
    x2: 21,
    y2: 21,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 24,
    y2: 15,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9,
    x2: 21,
    y2: 3,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyChatChannel);
export default __webpack_public_path__ + "static/media/property-chat-channel.60ce540d867eabe26de6e8f6b19594f7.svg";
export { ForwardRef as ReactComponent };